"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _subSidebar = _interopRequireDefault(require("./subSidebar"));
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AppMain',
  components: {
    SubSidebar: _subSidebar.default
  },
  props: ["currRouter"],
  computed: {
    cachedViews: function cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key: function key() {
      return this.$route.path;
    }
  }
};